module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6ElEQVQokWMU4OX7z8fHxxCXEM+AD5w6eYrh1MmTKCrAms3MzRkWLVmMVzMI3Lhxg6GyrJzh+vXrYD4TQR1IQENDg2HR0iUMmpqauDVrqKrBsbODI0N7axtcjpeXlyEwOIg4m58+fcqwcMEChg3r1sPFQN4k2dlwl2loEK/ZxdWFISAoEM4HBRwIsGBTvHjpEjjb1MwMQ37KpEm4NWPTAAKfP39myM7Mgsc3Vs2gwHny9AmK2NMnTxn27tnD8OnTJ7gYVs3r1q3DSE3YAFmhDQMDpxns56dPnjCcPnUKLngDmvDxAgYGBgBwzkjqifaBswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = fqxG
// module chunks = 1